import { useQueryClient } from '@tanstack/vue-query';
import { studentKeys } from './student.keys';

export function useRefreshStudents() {
  const queryClient = useQueryClient();

  // Refresh mounted lists and mark inactive class, school, and picker lists stale.
  const refreshStudents = async (): Promise<void> => {
    await queryClient.invalidateQueries({ queryKey: studentKeys.lists() });
  };

  return { refreshStudents };
}
